module.exports = __webpack_public_path__ + "img/s1_t1_17.02348ed0.jpeg";